import { render, staticRenderFns } from "./Markets.vue?vue&type=template&id=27592f00&scoped=true"
import script from "./Markets.vue?vue&type=script&lang=js"
export * from "./Markets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27592f00",
  null
  
)

export default component.exports